module.exports = __webpack_public_path__ + "img/concat2.85ead530.png";